<script>
    import { MemberCompanion, Member } from "shared/Models/memberClasses";
    import f9input from "inputs/f9input.vue";
    import f9field from "inputs/f9field.vue";
    import f9select from "inputs/f9select.vue";
    import f9date from "inputs/f9date.vue";
    import f9button from "inputs/f9button.vue";
    import passport from "./passport.vue";

    export default {
        props: {
            companion: MemberCompanion,
            saved: Boolean,
            disabled: Boolean,
            member: Member,
            validationScope: {
                type: String,
                default: "travel-companion"
            }
        },
        computed: {
            changed() {
                return this.companion && this.companion.changed;
            }
        },
        methods: {
            getName(companion) {
                var result = (companion.firstName + ' ' + companion.lastName).trim();

                if(result === "") {
                    return "<em>New Companion</em>"
                }

                return result;
            }
        },
        watch: {
            saved(val) {
                if(val) {
                    this.changed = false;
                }
            }
        },
        components: {
            f9input,
            f9select,
            f9date,
            f9button,
            passport,
            f9field
        },
        inject: ["$validator"]
    }
</script>

<template>
    <div class="companion vertical" @change="companion.changed = true" @keyup="companion.changed = true">
        <div class="companion-top horizontal center between">
            <f9button nostyle class="companion-name" :class="{ changed: changed && (companion.firstName || companion.lastName) }" @click="companion.expanded = !companion.expanded">
                <span data-cs-mask v-html="getName(companion)"></span>&nbsp;[{{ companion.expanded ? '-' : '+' }}]
            </f9button>
            <f9button nostyle class="companion-remove horizontal right center" @click="$emit('delete', companion)">Remove <img src="~images/Loyalty/Icons/remove.svg" alt=""></f9button>
        </div>
        <div class="companion-form left" :class="{ vertical: companion.expanded }" v-show="companion.expanded">
            <!-- FRONTIER Miles # -->
            <f9field>
                <span slot="label" class="slider-label"><em>FRONTIER Miles</em>&nbsp;#</span>
                <f9input :saved="!changed" v-model="companion.milesNumber" type="text" v-validate="'numeric'" name="member_number" 
                    :data-vv-scope="validationScope" :disabled="disabled"></f9input>
            </f9field>
            <div class="slider-form-row">
                <!-- First name -->
                <f9field label="First Name*">
                    <f9input :saved="!changed" v-model="companion.firstName" type="text" v-validate="'required'" name="first_name" 
                        :data-vv-scope="validationScope" :disabled="disabled"></f9input>
                </f9field>

                <!-- Middle name -->
                <f9field label="Middle Name">
                    <f9input :saved="!changed" v-model="companion.middleName" type="text" name="middle_name" :disabled="disabled"></f9input>
                </f9field>
            </div>

            <!-- Last Name -->
            <f9field label="Last Name*">
                <f9input :saved="!changed" v-model="companion.lastName" type="text" v-validate="'required'" name="last_name" 
                    :data-vv-scope="validationScope" :disabled="disabled"></f9input>
            </f9field>
            <div class="slider-form-row">
                <!-- Gender -->
                <f9field label="Gender*" half>
                    <f9select :saved="!changed" v-model="companion.gender" v-validate="'required'" name="gender" 
                        :data-vv-scope="validationScope" :disabled="disabled">
                        <option data-cs-mask>--</option>
                        <option data-cs-mask value="M">Male</option>
                        <option data-cs-mask value="F">Female</option>
                    </f9select>
                </f9field>

                <!-- Date of birth -->
                <f9field label="Date of Birth*" half>
                    <f9date :saved="!changed" v-model="companion.dob" name="birth_date" v-validate="'required'" 
                        :data-vv-scope="validationScope" :disabled="disabled"></f9date>
                </f9field>
            </div>

            <!-- Passport -->
            <div class="slider-field">
                <f9button nostyle class="slider-label" @click="companion.passportExpanded = !companion.passportExpanded">Passport [{{ companion.passportExpanded ? '-' : '+'}}]</f9button>
                <passport not-required v-show="companion.passportExpanded" :member="member" :passport="companion.passport" :allow-remove="false" :validation-scope="validationScope"></passport>
            </div>

            <!-- Known Traveler Number -->
            <f9field>
                <f9button nostyle class="slider-label" @click="companion.ktnExpanded = !companion.ktnExpanded">Known Traveler Number [{{ companion.ktnExpanded ? '-' : '+'}}]</f9button>
                <f9input v-show="companion.ktnExpanded" :saved="!changed" v-model="companion.knownTravelerNumber" type="text" v-validate="'alpha_num|min:7|max:25'" maxlength="25"
                    :data-vv-scope="validationScope" name="ktn" :disabled="disabled" class="sub-field"></f9input>
            </f9field>
            
            <!-- Redress Number -->
            <f9field>
                <f9button nostyle class="slider-label" @click="companion.redressExpanded = !companion.redressExpanded">Redress Number [{{ companion.redressExpanded ? '-' : '+'}}]</f9button>
                <f9input v-show="companion.redressExpanded" :saved="!changed" v-model="companion.redressNumber" type="text" v-validate="'alpha_num|min:6|max:13'" maxlength="13"
                    :data-vv-scope="validationScope" name="redress" :disabled="disabled" class="sub-field"></f9input>
            </f9field>
        </div>
    </div>
</template>

<style lang="less" scoped>
    @import "~less-variables";

    .companion {
        margin-top: 12px;

        .companion-top {
            font-size: 12px;
            line-height: 18px;

            .companion-name {
                color: @ibe-text--dark-gray;

                &.changed {
                    font-weight: 600;
                    color: @frontier-green;
                }
            }

            .companion-remove {
                color: @frontier-green;

                img {
                    width: 10px;
                    height: 10px;
                    margin-left: 5px;
                }
            }
        }
        .companion-form {
            margin-top: 12px;
            margin-left: 10px;

            .slider-field {
                margin-top: 8px;
            }
        }
    }
</style>

